<prcins-card pt="pt-0">
    <div body class="enroll-automatic-payment-section">
        <img src="assets/png/lightening.png" alt="tree">
        <div class="flex justify-center text-center info">
            <a [routerLink]="['../home/billing/change-plan']" prcins-tealium-tracker="click"
            prcins-tealium-event="enroll_eft">Enroll in Automatic Payments(EFT)</a>
        </div>
    </div>
</prcins-card>